import i18n from '@/utils/i18n';
import { getIdMembers } from '@/api/customer'
import { validMobile } from '@/utils/validate'
const state = {
  phones: '',
  names: '',
  memberArr: [],
  dataList: [],
};
const mutations = {
  SET_PHONES(state, val) {
    state.phones = val;
  },
  SET_PHONESARR(state, arr) {
    state.memberArr = arr;
  },
  SET_NAMES(state, val) {
    state.names = val;
  },
  SET_DATA_LIST(state, arr) {
    state.dataList = arr;
  },
};
const actions = {
  GET_ID_MEMBERS({ commit, state }, data) {
    const phones = [];
    data.v.split(',').map((e) => {
      if (validMobile(e)) {
        phones.push(e);
      }
    });
    if (phones.length) {
      getIdMembers({ phones: phones.join(',') }).then((res) => {
        const memberArr = res.data.map((e) => {
          if (e.levelCodeName) {
            return {
              levelCodeName:e.hotelLevelCodeName ? e.hotelLevelCodeName : i18n.t("modulesMember.drench") + e.levelCodeName,
              phone: e.phone
            }
          }
          // else {
          //   return {
          //     levelCodeName: i18n.t("common.unregisteredMember"),
          //     phone: e.phone
          //   }
          // }
        }).filter(Boolean);;
        // 去除重复手机号
        const resobj = {};
        res.data = res.data.reduce(function (item, next) {
          resobj[next.phone] ? '' : (resobj[next.phone] = true && item.push(next));
          return item;
        }, []);
        // 取交集
        if (data.o) {
          const obj = {};
          data.o = data.o.reduce(function (item, next) {
            obj[next.roomGuestTelephone || next.bookerTelephone]
              ? ''
              : (obj[next.roomGuestTelephone || next.bookerTelephone] = true && item.push(next));
            return item;
          }, []);
          const arr = [];
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < data.o.length; j++) {
              if (
                (data.o[j].roomGuestTelephone || data.o[j].bookerTelephone) === res.data[i].phone
              ) {
                res.data[i].name = data.o[j].roomGuestName || data.o[j].bookerName || '';
                arr.push(res.data[i]);
              }
            }
          }
          !data.ident && commit('SET_DATA_LIST', arr);
        } else {
          res.data.forEach((e) => {
            if (!e.name) {
              e.name = '';
            }
          });
          !data.ident && commit('SET_DATA_LIST', res.data);
        }
        commit('SET_PHONESARR', memberArr);
      });
    } else {
      !data.ident && commit('SET_DATA_LIST', []);
    }
  },
  GET_ID_NAMES({ commit, state }, data) {
    const names = data.v;
    commit('SET_NAMES', names);
  },
};
export default {
  state,
  mutations,
  actions,
};
